<template>
  <div class="clubhouse-navbar theme-platformbrand main-nav"
    v-if="route.name != 'Dashboard' && route.name != 'Reports'">
    <ul class="clubhouse-subnav-container sub-nav">
      <div class="clubhouse-subnav sub-nav-wrapper">
        <li v-for="(item, index) in menus" :key="index" @click="() => navigate(item.target)" :class="`nav ${route?.name == item.target.name ||
          (item.target.others && item.target.others.some((o) => o == route?.name))
          ? 'active branding-bg'
          : ''
          }`">
          <i :class="item.icon" class="m-2"></i>
          <a href="#" :class="`${route?.name == item.target.name ||
            (item.target.others && item.target.others.some((o) => o == route?.name))
            ? 'active'
            : ''
            }`" class="clubhouse-dropdown-item">{{ item.text }}</a>
        </li>
      </div>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import router from '../router'
import { useAuthStore } from '@/stores/auth-store'
import { storeToRefs } from 'pinia'
import { useSettingStore } from "@/stores/setting-store"
import { useTermsStore } from '@/stores/language-terms'

const { isClubhouseUser } = storeToRefs(useAuthStore())
const { getSetting } = useSettingStore();
const { setting } = storeToRefs(useSettingStore())
const { getTerms } = useTermsStore();
const { terms } = storeToRefs(useTermsStore());

const route = useRoute()
let sideNavMenus = ref(Array<any>())

onBeforeMount(async () => {
  await getSetting();
  await getTerms();
})

watch(terms, () => {
  sideNavMenus.value = [{
    icon: 'bi bi-bookmark-star',
    text: terms.value.ProgramPlural,
    target: {
      name: 'Participation',
      others: ['Participation-par', 'Participation-root', 'ParticipationProgram']
    }
  },
  {
    icon: 'bi bi-buildings',
    text: `${terms.value?.ParticipationRegionContactPlural}`,
    target: { name: 'StateContacts' },
    orgUserOnly: true
  },
  {
    icon: 'bi bi-person-badge',
    text: `${terms.value?.CommunityInstructorPlural}`,
    target: { name: 'Deliverers' },
    orgUserOnly: true
  }]
})

const menus = computed(() => {
  if (isClubhouseUser.value) {
    return sideNavMenus.value.filter((m) => !m.orgUserOnly);
  }
  return sideNavMenus.value;
})

const navigate = (route: any) => {
  router.push(route);
}
</script>

<style scoped>
.main-nav {
  margin-left: 15px;
  padding: 0;
  margin-top: 20px;
  display: block;
  border-top: none;
}

.sub-nav {
  display: block;
  background-color: #fff !important;
  padding-left: 0;
}

.sub-nav-wrapper {
  margin-left: 0;
}

.nav,
.nav:hover {
  display: block;
  text-decoration: none;
  width: 260px;
  text-align: left;
  font-size: medium;
  cursor: pointer;
  padding: 10px !important;
  color: rgba(0, 0, 0, 0.9);
}

.nav.active {
  border-bottom: none;
  color: white !important;
}

.nav a {
  text-decoration: none;
  color: black;
  cursor: pointer;
  caret-color: transparent;
}

.nav.active a.active {
  border-bottom: none;
  color: white !important;
}
</style>
